export default __webpack_public_path__ + "static/media/LanetteLovelace.740874fd.png";